import React, { useCallback } from 'react';
import { Container, Col, Row, Button, Image } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Haptics, ImpactStyle } from '@capacitor/haptics';
import './ProvinceButtonPage.css';

const PROVINCES_DATA = [
  { name: "Alberta", flag: "/albertaFlag.png", path: "/canada/alberta" },
  { name: "British Columbia", flag: "/britishColumbiaFlag.png", path: "/canada/british_columbia" },
  { name: "Manitoba", flag: "/manitobaFlag.png", path: "/canada/manitoba" },
  { name: "New Brunswick", flag: "/newBrunswickFlag.png", path: "/canada/new_brunswick" },
  { name: "Newfoundland & Labrador", flag: "/newfoundlandAndLabradorFlag.png", path: "/canada/newfoundland_labrador" },
  { name: "Northwest Territories", flag: "/northwestTerritoriesFlag.png", path: "/canada/northwest_territories" },
  { name: "Nova Scotia", flag: "/novaScotiaFlag.png", path: "/canada/nova_scotia" },
  { name: "Nunavut", flag: "/nunavutFlag.png", path: "/canada/nunavut" },
  { name: "Ontario", flag: "/ontarioFlag.png", path: "/canada/ontario" },
  { name: "Prince Edward Island", flag: "/princeEdwardIslandFlag.png", path: "/canada/prince_edward_island" },
  { name: "Quebec", flag: "/quebecFlag.png", path: "/canada/quebec" },
  { name: "Saskatchewan", flag: "/saskatchewanFlag.png", path: "/canada/saskatchewan" },
  { name: "Yukon", flag: "/yukonFlag.png", path: "/canada/yukon" }
];

const ProvinceButtonPage = ({ onProvinceSelect }) => {
  const handleClick = useCallback(async () => {
    try {
      await Haptics.impact({ style: ImpactStyle.Light });
    } catch (error) {
      // Haptics not available
    }
    if (onProvinceSelect) {
      onProvinceSelect();
    }
    window.scrollTo(0, 0);
  }, [onProvinceSelect]);

  return (
    <div className="province-page">
      <Container fluid className="province-container">
        <Row className="justify-content-center g-3">
          {PROVINCES_DATA.map(province => (
            <Col key={province.name} xs={6} sm={4} md={4} lg={3} className="d-flex justify-content-center">
              <Link 
                to={province.path}
                onClick={handleClick}
                className="province-link"
              >
                <Button className="province-button">
                  <Image 
                    src={province.flag} 
                    alt={`${province.name} Flag`}
                    className="province-flag"
                  />
                  <span className="province-name">{province.name}</span>
                </Button>
              </Link>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default ProvinceButtonPage;